import React, { useState, useContext } from 'react';
import "../../../ui-styles/tabStyles/HztlTabStyles.css";
import PatientPastAppointments from "./PatientPastAppointments";
import PatientMedicalProfile from "./PatientMedicalProfile";
import { LangCtx } from "../../../lib/context";

const PatientProfileView = (props) => {
    const [current, setTab] = useState("PA");
    const { l } = useContext(LangCtx);
    

    return (
        <>
            <div className="tabCol">
                <div className="row hndlpdn08">
                    <div className={current === "PA" ? "tabInline tabFlx1 flexFull active" : "tabInline flexFull tabFlx1"} onClick={(e) => setTab("PA")}>
                        <span>{l.past_appt}</span>
                    </div>
                    <div className={current === "MP" ? "tabInline tabFlx1 flexFull active" : "tabInline flexFull tabFlx1"} onClick={(e) => setTab("MP")}>
                        <span>{l.profile}</span>
                    </div>
                </div>
            </div>
            {current === "PA" && <PatientPastAppointments data={props.data}/>}
            {current === "MP" && <PatientMedicalProfile data={props.data}/>}
        </>
    )
}

export default PatientProfileView; 